<div class="d-flex navigation-header">
  <h1 (click)="goBack()" id="panel">{{"admin.title" | translate }}</h1>
  <h1>&nbsp; > {{"admin.manufacture.title" | translate}}</h1>
</div>

<div style="display: block; height: 240px;">
  <hr class="container-card">
  <h1>{{"admin.manufacture.selectAttributes" | translate}}</h1>

  <div style="display: flex; float: left;">
    <div style="display: block; margin-right: 20px; width: 160px;">
      <label for="lensGroups">
        <h2 style="margin-bottom: 0">{{"admin.manufacture.lensGroups" | translate}}</h2>
      </label>
      <div>
        <select [(ngModel)]="selectedLensGroups" name="lensGroups" id="lensGroups" multiple
                style="width: 160px; font-size: large">
          <option *ngFor="let lensGroup of lensGroups" [value]="lensGroup">{{lensGroup}}</option>
        </select>
      </div>
    </div>
    <div style="display: block; margin-right: 20px; width: 180px;">
      <label for="materials">
        <h2 style="margin-bottom: 0">{{"admin.manufacture.materials" | translate}}</h2>
      </label>
      <div>
        <select [(ngModel)]="selectedMaterials" name="materials" id="materials" multiple
                style="width: 180px; font-size: large">
          <option *ngFor="let material of materials" [value]="material">{{material}}</option>
        </select>
      </div>
    </div>
    <div style="display: block; margin-right: 20px; width: 160px;">
      <label for="countries">
        <h2 style="margin-bottom: 0">{{"admin.manufacture.countries" | translate}}</h2>
      </label>
      <div>
        <select [(ngModel)]="selectedCountries" name="countries" id="countries" multiple
                style="width: 160px; font-size: large">
          <option *ngFor="let country of countries" [value]="country">{{country}}</option>
        </select>
      </div>
    </div>
    <div style="display: block; margin-right: 20px; width: 60px;">
      <label for="prism">
        <h2 style="margin-bottom: 0">{{"common.hints.Prism" | translate}}</h2>
      </label>
      <div style="display: block;">
        <input [(ngModel)]="selectedPrism" type="checkbox" id="prism" name="prism" style="width: 30px; height: 30px; margin-left: 10px;">
      </div>
    </div>
    <div style="display: block; margin-right: 20px; width: 60px;">
      <label for="days">
        <h2 style="margin-bottom: 0">{{"admin.manufacture.days" | translate}}</h2>
      </label>
      <div>
        <input [(ngModel)]="selectedDays" type="number" min="1" max="300" id="days" name="days"
               style="width: 56px; height: 30px; font-size: larger">
      </div>
    </div>
    <div style="display: block; margin: 40px 20px;">
      <input type="submit" value="{{'admin.manufacture.submit' | translate}}" [disabled]="!checkSelected()" (click)="pushSelected()"
             style="font-size: large; width: 100px; height: 30px;">
    </div>
    <div style="display: block; margin: 40px 160px;">
      <button style="border:1px solid; -webkit-border-radius: 5px; border-radius: 5px; width: 80px; height: 80px; font-size: large;">
      <input id="file" type="file" (change)="onFileChanged($event)" style="display: none">
      <label for="file" style="cursor: pointer">
        {{'admin.manufacture.offDays' | translate}}
      </label>
      </button>
    </div>
  </div>
  <div style="display: flex; float: left; margin-top: 20px;">
    <p [innerHtml]="'admin.manufacture.hint' | translate"></p>
  </div>
</div>

<div style="display: block;">
  <hr class="container-card">
  <h1>{{'admin.manufacture.table' | translate}}</h1>
  <div>
    <table mat-table [dataSource]="tableItems" matSort (matSortChange)="sortData($event)" class="mat-elevation-z8"
           style="width: 100%">
      <ng-container matColumnDef="lensGroup">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="lensGroup">{{"admin.manufacture.lensGroup" | translate}}</th>
        <td mat-cell *matCellDef="let row">{{row.lensGroup}}</td>
      </ng-container>
      <ng-container matColumnDef="material">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="material">{{"admin.manufacture.material" | translate}}</th>
        <td mat-cell *matCellDef="let row">{{row.material}}</td>
      </ng-container>
      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="country">{{"admin.manufacture.country" | translate}}</th>
        <td mat-cell *matCellDef="let row">{{row.country}}</td>
      </ng-container>
      <ng-container matColumnDef="prism">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="prism">{{"common.hints.Prism" | translate}}</th>
        <td mat-cell *matCellDef="let row">{{row.prism}}</td>
      </ng-container>
      <ng-container matColumnDef="days">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="days">{{"admin.manufacture.days" | translate}}</th>
        <td mat-cell *matCellDef="let row" style="width: 70px;">{{row.days}}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[7, 10, 15, 20]" showFirstLastButtons color="standart"
                   #itemPaginator="matPaginator"></mat-paginator>
  </div>
</div>
